export default __webpack_public_path__ + "static/media/download-android-en.1633825b.png";